import React from 'react'

const MobileNavMenu = () => (
    <>
    </>
)

export default MobileNavMenu